import { ApiTosVersion } from "avvir";

import { AvvirEvent } from "type_aliases";

export type LatestTosLoadedEvent = AvvirEvent<typeof LATEST_TOS_LOADED, ApiTosVersion>

const latestTosLoaded = (apiTos: ApiTosVersion): LatestTosLoadedEvent => ({
  type: LATEST_TOS_LOADED,
  payload: apiTos,
});

export const LATEST_TOS_LOADED = "latest_tos_loaded";

export default latestTosLoaded;
